import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface BackupResult {
    success: boolean;
    message: string;
    jobId?: string;
    collections: string[];
    totalDocuments: number;
}

export interface JobStatus {
    jobId: string;
    status: 'pending' | 'in_progress' | 'completed' | 'failed';
    progress: number;
    processed_items: number;
    total_items: number;
    error?: string;
}

interface BackupState {
    loading: boolean;
    error: string | null;
    backupResult: BackupResult | null;
    jobStatus: Partial<JobStatus>;
}

const initialState: BackupState = {
    loading: false,
    error: null,
    backupResult: null,
    jobStatus: {},
};

const backupSlice = createSlice({
    name: 'backup',
    initialState,
    reducers: {
        startAtlasBackup: (state) => {
            state.loading = true;
            state.error = null;
            state.backupResult = null;
            state.jobStatus = {};
        },
        startAtlasBackupSuccess: (state, action: PayloadAction<BackupResult>) => {
            state.loading = false;
            state.backupResult = action.payload;
            state.jobStatus = {
                jobId: action.payload.jobId,
                status: 'in_progress',
                progress: 0,
                processed_items: 0,
                total_items: action.payload.totalDocuments,
            };
        },
        startAtlasBackupFailed: (state, action: PayloadAction<string>) => {
            state.loading = false;
            state.error = action.payload;
        },
        updateBackupJobStatus: (state, action: PayloadAction<JobStatus>) => {
            state.jobStatus = action.payload;
        },
        clearBackupState: (state) => {
            state.loading = false;
            state.error = null;
            state.backupResult = null;
            state.jobStatus = {};
        },
    },
});

export const {
    startAtlasBackup,
    startAtlasBackupSuccess,
    startAtlasBackupFailed,
    updateBackupJobStatus,
    clearBackupState,
} = backupSlice.actions;

export default backupSlice.reducer;

